"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Set the selectedFolderId in the inbox rules store
 * @param id the folder ID to set
 */
exports.default = legacy_1.action('setSelectedFolderId')(function setSelectedFolderId(id) {
    store_1.default.inboxRulesEditState.selectedFolderId = id;
});
//# sourceMappingURL=setSelectedFolderId.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/setSelectedFolderId.js
// module id = 3386
// module chunks = 2 90